import { mobileAndTabletCheck } from "./helps";

function ControlPage() {
    let groups;
    function init() {
        console.log('is home', isHome);
        if (isHome && false) {
            setupSections();
            jQuery(window).on('scroll', orderLayers);
            orderLayers();
        }
        

    }
    
    function orderLayers() {
        const scrollY = window.scrollY;
        const heightWindow = jQuery(window).height();
        const secondLayer = jQuery(groups[1]);
        const thirdLayer = jQuery(groups[2]);
        if (scrollY >= heightWindow) {
            secondLayer.removeClass("wp-block-group--static");
            thirdLayer.css({
                margin: 0
            });
        } else {
            const firstLayer = jQuery(groups[0]);
            secondLayer.addClass("wp-block-group--static");
            const opacity = 1.3 - 2 * scrollY / (heightWindow);
            const heightPreview = secondLayer.height() + 71;
            const top = `${heightPreview}px`;
            const childs = secondLayer.find("> div");
            const y = 100 - 100 * Math.min(1, 2 * scrollY / heightPreview);
            const opacityChilds = 1.2 - y / 100;
            childs.css({
                transform: `translateY(${y}px)`,
                opacity: opacityChilds,
            });
            thirdLayer.css({
                marginTop: top
            });
            firstLayer.css({
                opacity
            })
        }
        orderLastChild();
    }
    function orderLastChild() {
        let pos = 1;

        do {
            const lastLayer = jQuery(groups[groups.length - pos]);
            const tagName = lastLayer.prop('tagName').toLowerCase();
            if (tagName === 'style' || tagName === 'script') {
                pos++;
                continue;
            } else {
                const footer = jQuery("footer").height();
                lastLayer.css({
                    marginBottom: `${footer}px`
                });
                break;
            }


        } while (false);

    }
    function setupSections() {
        groups = jQuery('.wrapper-parallax').children();
        //console.log('groups', groups);
        const secondLayer = jQuery(groups[1]);
        const thirdLayer = jQuery(groups[2]);

        secondLayer.addClass("wp-block-group--static");
        const heightPreview = secondLayer.height() + 71;
        const top = `${heightPreview}px`;
        //console.log('heisecnod', secondLayer[0], secondLayer.height());
        
        secondLayer.css({
            display:'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: '100vh'
        });
        thirdLayer.css({
            marginTop: top
        });
        orderLastChild();

    }
    init();
}
new ControlPage();